import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import {
  CopySettingsRequest,
  CreateLocationUserRequest,
  CreateUpdateLocationRequest,
  Location,
} from '@shared/location/models';
import { LocationUser } from '@shared/user/models';
import { Invite } from '@shared/invite/models';
import { ApiClientService } from '@tablesready/api-client';

@Injectable({providedIn: 'root'})
export class LocationApiService {
  private readonly basePath = '/v.1/location';

  constructor(
    private readonly http: ApiClientService,
  ) {
  }

  create(body: CreateUpdateLocationRequest): Observable<Location> {
    return this.http.post<Location>(this.basePath, body);
  }

  updateById(locationId: string, body: CreateUpdateLocationRequest): Observable<void> {
    return this.http.put<void>(`${this.basePath}/${locationId}`, body);
  }

  updateAvailability(locationId: string, enabled: boolean): Observable<void> {
    return this.http.patch<void>(`${this.basePath}/${locationId}`, {enabled});
  }

  deleteById(id: string): Observable<void> {
    return this.http.delete<void>(`${this.basePath}/${id}`);
  }

  deleteLocationUser(locationUserId: string): Observable<void> {
    return this.http.delete<void>(`${this.basePath}/location-users/${locationUserId}`);
  }

  updateLocationUser(locationUserId: string, role: string): Observable<void> {
    return this.http.put<void>(`${this.basePath}/location-users/${locationUserId}`, { role });
  }

  createLocationUser(data: CreateLocationUserRequest): Observable<void> {
    return this.http.post<void>(`${this.basePath}/location-users`, data);
  }

  getLocationUsers(): Observable<LocationUser[]> {
    return this.http.get<LocationUser[]>(`${this.basePath}/location-users`);
  }

  getInvites(): Observable<Invite[]> {
    return this.http.get<Invite[]>(`${this.basePath}/invites`);
  }

  copySettings(body: CopySettingsRequest): Observable<void> {
    return this.http.post<void>(`${this.basePath}/copy-settings`, body);
  }
}
